import "./app.less";
import React, { useState, useEffect } from "react";
import { Router, Redirect } from "@reach/router";
import { navigate } from "@reach/router";
import {
  message,
  Alert,
  Dropdown,
  Badge,
  Layout,
  Menu,
  Breadcrumb,
  Icon,
  Row,
  Col,
  Popover,
  Button,
  Modal,
} from "antd";
import CustomAvatar from "./components/customAvatar";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import { faTachometerAlt } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { faUserFriends } from "@fortawesome/free-solid-svg-icons";
import { faTasks } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { faFileInvoiceDollar } from "@fortawesome/free-solid-svg-icons";
// import { faMailBulk } from '@fortawesome/free-solid-svg-icons'
import { faHdd } from "@fortawesome/free-solid-svg-icons";
import { faFileInvoice } from "@fortawesome/free-solid-svg-icons";
import { faFileAlt } from "@fortawesome/free-solid-svg-icons";
import { faMoneyBill } from "@fortawesome/free-solid-svg-icons";

import moment from "moment";
import { getMyaccount } from "./API";

import HOC from "./components/HOC";
import OnlyAdmin from "./components/onlyAdmin";

import Login from "./layout/login";
import MyAccount from "./layout/myaccount";
import MyDrive from "./layout/mydrive";
import Dashboard from "./layout/dashboard";
import Clients from "./layout/clients";
import Client from "./layout/client";
import Contacts from "./layout/contacts";
import Contact from "./layout/contact";
import Candidates from "./layout/candidates";
import Candidate from "./layout/candidate";
import Events from "./layout/events";
import Emails from "./layout/emails";
import Search from "./layout/search";
// import BannedEmails from './layout/bannedemails';
import Invoices from "./layout/invoices";
import Invoice from "./layout/invoice";
import Offers from "./layout/offers";
import Jobs from "./layout/jobs";
import Invest from "./layout/invest";

import {
  flexCenterRight,
  flexCenter,
  minHeight,
  primaryTextColor,
} from "./theme";

import { allNationsWithCaptial } from "./utils/countries";

import { useMappedState, useDispatch } from "redux-react-hook";

const { Header, Content, Sider, Footer } = Layout;

function App() {
  let nations = allNationsWithCaptial();

  const getMenuIndex = (path) => {
    if (path.includes("/dashboard")) {
      return "1";
    }
    if (path.includes("/myaccount")) {
      return "2";
    }
    if (path.includes("/clients")) {
      return "3";
    }
    if (path.includes("/contacts")) {
      return "4";
    }
    if (path.includes("/candidates")) {
      return "5";
    }
    if (path.includes("/activities")) {
      return "6";
    }
    if (path.includes("/emails")) {
      return "7";
    }
    if (path.includes("/search")) {
      return "8";
    }
    // if (path.includes('/bannedemails')) {
    //   return "9";
    // }
    if (path.includes("/mydrive")) {
      return "10";
    }
    if (path.includes("/invoices")) {
      return "11";
    }
    if (path.includes("/offers")) {
      return "12";
    }
    if (path.includes("/jobs")) {
      return "13";
    }
    if (path.includes("/invest")) {
      return "14";
    }
    return "1";
  };
  const app = useMappedState((state) => state.app);
  const session = useMappedState((state) => state.session);
  const messageCenter = useMappedState((state) => state.messageCenter);
  const dispatch = useDispatch();

  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    async function fetchMe() {
      const me = await getMyaccount(session.authToken);
      dispatch({ type: "INIT_ME", payload: me.data.me });
    }

    if (session.isAuthorised) {
      dispatch({
        type: "SET_INDEX",
        payload: getMenuIndex(window.location.pathname),
      });
      fetchMe();
    } else {
      dispatch({ type: "SET_INDEX", payload: "1" });
    }
    // eslint-disable-next-line
  }, []);

  const content = (
    <div>
      <Button
        onClick={() => {
          dispatch({ type: "CLEAR_SESSION" });
          message.success("log out successful");
          dispatch({ type: "SET_INDEX", payload: "1" }); //reset highlight sidebar
        }}
        type="primary"
        icon="logout"
      >
        Log Out
      </Button>
    </div>
  );

  const getResumeReminderData = () => {
    const data = app.resumeReminder.map((i) => {
      return i.data;
    });
    return data.flat().filter((i) => i.status === "error");
  };

  const resumeReminderMenu = (
    <Menu>
      {getResumeReminderData().map((i) => {
        return (
          <Menu.Item key={i._id}>
            <Alert
              message={
                <div>
                  {i.provider}-{i.savedJob_doc.search.locations}-
                  {i.savedJob_doc.search.and}:&nbsp;&nbsp;{i.meta.message} on{" "}
                  {moment(i.createdAt).format("YYYY-MM-DD")}
                </div>
              }
              type="error"
              showIcon
            />
          </Menu.Item>
        );
      })}
    </Menu>
  );

  const getReminderData = () => {
    const data = app.jobReminder.map((i) => {
      return i.data;
    });
    return data
      .flat()
      .filter((i) => i.status === "error" || i.status === "warning");
  };

  const jobReminderMenu = () => {
    const getName = (code, nations) => {
      const found = nations.find((i) => i.code === code);
      return found.name;
    };
    const getMessage = (message) => {
      if (message.includes("jsondata not found")) {
        return "job not found";
      }
      if (message.includes("request error")) {
        return "request error";
      }
    };

    return (
      <Menu>
        {getReminderData().map((i) => {
          return (
            <Menu.Item key={`${i._id}`}>
              <Alert
                message={
                  <div>
                    {i.companyName}-{getName(i.country, nations)}:&nbsp;&nbsp;
                    {getMessage(i.meta.message)} on{" "}
                    {moment(i.createdAt).format("YYYY-MM-DD")}
                  </div>
                }
                type={i.status}
                showIcon
              />
            </Menu.Item>
          );
        })}
      </Menu>
    );
  };

  return session.isAuthorised ? (
    <div className="App">
      {/* this modal serve all message display */}
      <Modal
        zIndex={9999}
        centered={true}
        closable={false}
        visible={messageCenter.showMsgModal}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              dispatch({ type: "CLOSE_MSG_MODAL" });
            }}
          >
            <Icon type="close" />
            Close
          </Button>,
        ]}
      >
        <p style={{ fontSize: "16px" }}>
          <Icon
            type="warning"
            theme="twoTone"
            twoToneColor="red"
            style={{ fontSize: "24px" }}
          />
          &nbsp;&nbsp;
          {messageCenter.msgBody}
        </p>
      </Modal>

      {/* this modal only serve authToken error handle */}
      <Modal
        centered={true}
        closable={false}
        visible={messageCenter.showAuthTokenModal}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              dispatch({ type: "CLEAR_SESSION" });
              dispatch({ type: "TOGGLE_AUTH_TOKEN_MODAL" });
              dispatch({ type: "SET_INDEX", payload: "1" }); //reset highlight sidebar
            }}
          >
            <Icon type="check" />
            OK, I got it
          </Button>,
        ]}
      >
        <p style={{ fontSize: "16px" }}>
          <Icon
            type="warning"
            theme="twoTone"
            twoToneColor="red"
            style={{ fontSize: "24px" }}
          />
          &nbsp;&nbsp; Authentication token expired, please login again
        </p>
      </Modal>

      <Layout style={minHeight}>
        <Sider trigger={null} collapsible collapsed={collapsed}>
          <div
            className="logo"
            style={{ ...flexCenter, ...{ height: "60px" } }}
          >
            <span style={primaryTextColor}>
              {collapsed ? "LG" : "Link Global"}
            </span>
          </div>
          <Menu theme="dark" selectedKeys={[app.index]} mode="inline">
            <Menu.Item
              key="1"
              onClick={() => {
                dispatch({ type: "SET_INDEX", payload: "1" });
                navigate("/dashboard");
              }}
            >
              <Icon style={{ fontSize: "16px" }}>
                <FontAwesomeIcon icon={faTachometerAlt} />
              </Icon>
              <span>Dashboard</span>
            </Menu.Item>
            <Menu.Item
              key="2"
              onClick={() => {
                dispatch({ type: "SET_INDEX", payload: "2" });
                navigate("/myaccount");
              }}
            >
              <Icon style={{ fontSize: "16px" }}>
                <FontAwesomeIcon icon={faUser} />
              </Icon>
              <span>My Account</span>
            </Menu.Item>
            <Menu.Item
              key="12"
              onClick={() => {
                dispatch({ type: "SET_INDEX", payload: "12" });
                navigate("/offers");
              }}
            >
              <Icon style={{ fontSize: "16px" }}>
                <FontAwesomeIcon icon={faFileInvoice} />
              </Icon>
              <span>Offers</span>
            </Menu.Item>
            <Menu.Item
              key="11"
              onClick={() => {
                dispatch({ type: "SET_INDEX", payload: "11" });
                navigate("/invoices");
              }}
            >
              <Icon style={{ fontSize: "16px" }}>
                <FontAwesomeIcon icon={faFileInvoiceDollar} />
              </Icon>
              <span>Invoices</span>
            </Menu.Item>
            <Menu.Item
              key="10"
              onClick={() => {
                dispatch({ type: "SET_INDEX", payload: "10" });
                navigate("/mydrive");
              }}
            >
              <Icon style={{ fontSize: "16px" }}>
                <FontAwesomeIcon icon={faHdd} />
              </Icon>
              <span>My Drive</span>
            </Menu.Item>
            <Menu.Item
              key="3"
              onClick={() => {
                dispatch({ type: "SET_INDEX", payload: "3" });
                navigate("/clients");
              }}
            >
              <Icon style={{ fontSize: "16px" }}>
                <FontAwesomeIcon icon={faBuilding} />
              </Icon>
              <span>Clients</span>
            </Menu.Item>
            <Menu.Item
              key="4"
              onClick={() => {
                dispatch({ type: "SET_INDEX", payload: "4" });
                navigate("/contacts");
              }}
            >
              <Icon style={{ fontSize: "16px" }}>
                <FontAwesomeIcon icon={faUserFriends} />
              </Icon>
              <span>Contacts</span>
            </Menu.Item>
            <Menu.Item
              key="5"
              onClick={() => {
                dispatch({ type: "SET_INDEX", payload: "5" });
                navigate("/candidates");
              }}
            >
              <Icon style={{ fontSize: "16px" }}>
                <FontAwesomeIcon icon={faUsers} />
              </Icon>
              <span>Candidates</span>
            </Menu.Item>
            {session.scope === "admin" ? (
              <Menu.Item
                key="13"
                onClick={() => {
                  dispatch({ type: "SET_INDEX", payload: "13" });
                  navigate("/jobs");
                }}
              >
                <Icon style={{ fontSize: "16px" }}>
                  <FontAwesomeIcon icon={faFileAlt} />
                </Icon>
                <span>Jobs</span>
              </Menu.Item>
            ) : null}
            {session.scope === "admin" ? (
              <Menu.Item
                key="14"
                onClick={() => {
                  dispatch({ type: "SET_INDEX", payload: "14" });
                  navigate("/invest");
                }}
              >
                <Icon style={{ fontSize: "16px" }}>
                  <FontAwesomeIcon icon={faMoneyBill} />
                </Icon>
                <span>Invest</span>
              </Menu.Item>
            ) : null}
            <Menu.Item
              key="6"
              onClick={() => {
                dispatch({ type: "SET_INDEX", payload: "6" });
                navigate("/activities");
              }}
            >
              <Icon style={{ fontSize: "16px" }}>
                <FontAwesomeIcon icon={faTasks} />
              </Icon>
              <span>Activities</span>
            </Menu.Item>
            <Menu.Item
              key="7"
              onClick={() => {
                dispatch({ type: "SET_INDEX", payload: "7" });
                navigate("/emails");
              }}
            >
              <Icon style={{ fontSize: "16px" }}>
                <FontAwesomeIcon icon={faEnvelope} />
              </Icon>
              <span>Emails</span>
            </Menu.Item>
            {/* <Menu.Item key="9" onClick={() => { dispatch({ type: "SET_INDEX", payload: "9" }); navigate("/bannedemails") }}>
                <Icon style={{ fontSize: "16px" }}><FontAwesomeIcon icon={faMailBulk} /></Icon>
                <span>Banned Emails</span>
              </Menu.Item> */}
            <Menu.Item
              key="8"
              onClick={() => {
                dispatch({ type: "SET_INDEX", payload: "8" });
                navigate("/search");
              }}
            >
              <Icon style={{ fontSize: "16px" }}>
                <FontAwesomeIcon icon={faSearch} />
              </Icon>
              <span>Search</span>
            </Menu.Item>
          </Menu>
        </Sider>
        <Layout>
          <Header style={{ background: "#fff", padding: 0 }}>
            <Row>
              <Col span={16}>
                <div style={{ marginLeft: "20px" }}>
                  <Icon
                    onClick={() => {
                      setCollapsed(!collapsed);
                    }}
                    type={`${collapsed ? "menu-unfold" : "menu-fold"}`}
                    style={{ fontSize: "24px" }}
                  />
                </div>
              </Col>
              <Col span={8}>
                <div
                  style={{
                    ...{ marginRight: "20px", height: "100%" },
                    ...flexCenterRight,
                  }}
                >
                  <div style={{ marginTop: "6px" }}>
                    <OnlyAdmin
                      scope={session.scope}
                      element={
                        <div>
                          {getReminderData().length > 0 ? (
                            <Badge count={getReminderData().length}>
                              <Dropdown
                                overlay={jobReminderMenu}
                                placement="bottomRight"
                              >
                                <Icon
                                  theme="twoTone"
                                  twoToneColor="#eb2f96"
                                  type="notification"
                                  style={{ fontSize: "24px" }}
                                />
                              </Dropdown>
                            </Badge>
                          ) : null}
                        </div>
                      }
                    />
                  </div>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <div style={{ marginTop: "6px" }}>
                    <OnlyAdmin
                      scope={session.scope}
                      element={
                        <div>
                          {getResumeReminderData().length > 0 ? (
                            <Badge count={getResumeReminderData().length}>
                              <Dropdown
                                overlay={resumeReminderMenu}
                                placement="bottomRight"
                              >
                                <Icon
                                  theme="twoTone"
                                  twoToneColor="#eb2f96"
                                  type="profile"
                                  style={{ fontSize: "24px" }}
                                />
                              </Dropdown>
                            </Badge>
                          ) : null}
                        </div>
                      }
                    />
                  </div>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <Popover
                    placement="bottomRight"
                    content={content}
                    trigger="click"
                  >
                    <span style={{ cursor: "pointer" }}>
                      {session.firstname} {session.lastname}
                    </span>
                    &nbsp;&nbsp;
                    <CustomAvatar
                      style={{ cursor: "pointer" }}
                      colourCode={session.firstname.charAt(0).toLowerCase()}
                      char={`${session.firstname
                        .charAt(0)
                        .toUpperCase()}${session.lastname
                        .charAt(0)
                        .toUpperCase()}`}
                      charSize={16}
                      size={30}
                      src={session.avatar}
                    />
                  </Popover>
                </div>
              </Col>
            </Row>
          </Header>

          <Content style={{ margin: "0 16px" }}>
            <Breadcrumb style={{ margin: "16px 0" }} />
            <div
              style={{ padding: 24, background: "#fff", minHeight: "100hv" }}
            >
              <Router>
                <HOC path="/myaccount" Component={MyAccount} />
                <HOC path="/mydrive" Component={MyDrive} />
                <HOC path="/dashboard" Component={Dashboard} />
                <HOC path="/clients" Component={Clients} />
                <Client path="/clients/:id" />
                <HOC path="/contacts" Component={Contacts} />
                <Contact path="/contacts/:id" />
                <HOC path="/candidates" Component={Candidates} />
                <Candidate path="/candidates/:id" />
                <HOC path="/activities" Component={Events} />
                <HOC path="/offers" Component={Offers} />
                <HOC path="/invoices" Component={Invoices} />
                <Invoice path="/invoices/:id" />
                <HOC path="/emails" Component={Emails} />
                <HOC path="/search" Component={Search} />
                {/* <BannedEmails path="/bannedemails" /> */}
                {session.scope === "admin" ? (
                  <HOC path="/jobs" Component={Jobs} />
                ) : null}
                {session.scope === "admin" ? (
                  <HOC path="/invest" Component={Invest} />
                ) : null}
                <Redirect from="/dashboard" to="/dashboard" default noThrow />
              </Router>
            </div>
          </Content>
          <Footer style={{ textAlign: "center" }}>
            {`© 2020 - ${moment().format(
              "YYYY"
            )} Copyright Link Global. All Rights Reserved. v${
              process.env.REACT_APP_VERSION
            }`}
          </Footer>
        </Layout>
      </Layout>
    </div>
  ) : (
    <Router>
      <Login path="/" />
      <Redirect from="/" to="/" default noThrow />
    </Router>
  );
}

export default App;
